import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import MainLayout from './MainLayout';
import TopNavBar from './TopNavBar';
import { useAuth } from '../context/AuthContext';
import { FiClock, FiSettings, FiSave, FiAlertCircle } from 'react-icons/fi';
import { RiToggleLine, RiToggleFill } from 'react-icons/ri';
import '../styles/reportsettings.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3030';

export default function CheckinSettings({ isTab = false }) {
    const { user, logout } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const [settings, setSettings] = useState({
        is_enabled: true,
        schedule_time: '09:45'
    });

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${API_BASE_URL}/api/report-settings/checkin`);
            setSettings({
                is_enabled: res.data.is_enabled,
                schedule_time: res.data.schedule_time || '09:45'
            });
        } catch (err) {
            console.error(err);
            toast.error("Failed to load check-in reminder settings");
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            await axios.post(`${API_BASE_URL}/api/report-settings/checkin`, settings);
            toast.success("Check-in reminder settings updated successfully");
        } catch (err) {
            console.error(err);
            toast.error("Failed to save settings");
        } finally {
            setSaving(false);
        }
    };

    const content = (
        <div className="report-settings-page">
            {!isTab && (
                <div className="settings-header">
                    <div className="header-info">
                        <h1>Check-In Reminder Settings</h1>
                        <p>Configure automated reminders and LOP evaluation for late check-ins</p>
                    </div>
                </div>
            )}

            <div className="settings-container">
                <div className="settings-card">
                    <div className="card-header">
                        <FiSettings className="card-icon" />
                        <span>Daily Check-In Reminder Configuration</span>
                    </div>

                    <div className="card-body">
                        {/* Enable/Disable Toggle */}
                        <div className="setting-row toggle-row">
                            <div className="setting-info">
                                <h3>Enable Automated Reminders</h3>
                                <p>When enabled, system will send reminders and evaluate LOP based on the schedule below</p>
                            </div>
                            <div
                                className={`toggle-btn ${settings.is_enabled ? 'enabled' : ''}`}
                                onClick={() => setSettings({ ...settings, is_enabled: !settings.is_enabled })}
                            >
                                {settings.is_enabled ? <RiToggleFill size={40} color="#0ea5e9" /> : <RiToggleLine size={40} color="#94a3b8" />}
                            </div>
                        </div>

                        <hr className="divider" />

                        {/* Schedule Time */}
                        <div className="setting-row">
                            <div className="setting-info">
                                <div className="label-with-icon">
                                    <FiClock />
                                    <h3>Schedule Time</h3>
                                </div>
                                <p>At what time should the reminder be sent and 3-strike LOP be evaluated?</p>
                            </div>
                            <div className="setting-input">
                                <input
                                    type="time"
                                    value={settings.schedule_time}
                                    onChange={(e) => setSettings({ ...settings, schedule_time: e.target.value })}
                                />
                                <span className="timezone-label">Asia/Kolkata (IST)</span>
                            </div>
                        </div>

                        <div className="info-banner">
                            <FiAlertCircle />
                            <span>Note: The reminder evaluates check-ins and applies 1 Day LOP for every 3 violations without approved leave or permission.</span>
                        </div>
                    </div>

                    <div className="card-footer">
                        <button
                            className="btn-save"
                            onClick={handleSave}
                            disabled={saving}
                        >
                            {saving ? 'Saving...' : <><FiSave /> Save Configuration</>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

    if (isTab) return content;

    return (
        <MainLayout sidebarOpen={sidebarOpen} toggleSidebar={() => setSidebarOpen(p => !p)}>
            {content}
        </MainLayout>
    );
}
